import { getResourceType } from '../components/ResourceTypeIcon';
import { backgroundColors } from '../dag/resourceConstants';

type GetNodeColorParams = {
  resourceType: string;
  showColor: boolean;
};

export const getResourceNodeColor = ({ showColor, ...params }: GetNodeColorParams) => {
  const resourceType = getResourceType(params.resourceType) ?? 'unknown';

  return showColor ? `${backgroundColors[resourceType]}` : 'bg-bgMain';
};

type NodeColorParams = {
  resourceType: string;
  showColor: boolean;
};

export const useResourceNodeColors = (params: NodeColorParams) => {
  return getResourceNodeColor(params);
};
